<template>
    <div class="search-layout bg-gray-100">
        <!-- Main Content -->
        <div class="search-layout-main-content container" style="max-width: 90%;padding: 0px;">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SearchLayout'
}
</script>